// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomDealGroupsComponent } from './custom-deal-groups/custom-deal-group.component';
import { DealsGuard } from '@services/route-guards/permissions/deals.guard';
import { PendingChangesGuard } from '@services/route-guards/pending-changes.guard';
import { FAndIFormsGuard } from '../../services/route-guards/permissions/f-and-i-forms.guard';

const routes: Routes = [
    {
        path: '',
        component: CustomDealGroupsComponent,
        canDeactivate: [PendingChangesGuard],
        canActivate: [FAndIFormsGuard],
        data: {
            headerTooltip:
                'Click the Create Custom Deal Type button to add a new deal type or select an existing deal type from the list to review, modify or delete it. For details and guidance on Custom Deal Types, click Learn More on the right side of the screen.',
        },
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full',
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class CustomDealGroupsRoutingModule {}
